var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('MenuDesktop',{staticClass:"menu-desktop",attrs:{"menuOptions":_vm.menuOptions}}),_c('MenuMobile',{staticClass:"menu-mobile",attrs:{"menuOptions":_vm.menuOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }